module.exports = __webpack_public_path__ + "img/cart-icon-music.7e046b24.svg";